import React from 'react'
import { Activity } from 'lucide-react'
import { formatSignedPercent } from '../utils/format'
import { toneColor } from '../utils/tone'
import { useDesk } from '../deskContext'

export default function RelativeStrength({ quote }) {
  const desk = useDesk()
  const peers = quote?.peers
  if (!peers?.length) return null

  const onds = quote.dayChangeRatio ?? 0
  const avg = peers.reduce((s, p) => s + (p.dayChangeRatio ?? 0), 0) / peers.length
  const rel = onds - avg
  const relTone = rel >= 0 ? 'bull' : 'bear'

  const chips = [{ symbol: quote?.ticker || desk.ticker, dayChangeRatio: onds, self: true }, ...peers]

  return (
    <div className="onds-card p-4 md:p-5">
      <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Activity className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
          <h2 className="text-base md:text-lg font-bold">Relative Strength · Today</h2>
        </div>
        <div className="text-sm">
          <span className="text-[var(--onds-text-dim)]">{quote?.ticker || desk.ticker} vs peer complex: </span>
          <span className="font-bold tabular-nums" style={{ color: toneColor(relTone) }}>{formatSignedPercent(rel)}</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {chips.map((p) => {
          const color = toneColor((p.dayChangeRatio ?? 0) >= 0 ? 'bull' : 'bear')
          return (
            <div
              key={p.symbol}
              className="flex items-center gap-2 rounded-lg px-3 py-1.5 border"
              style={{
                borderColor: p.self ? 'var(--onds-accent)' : 'var(--onds-border)',
                backgroundColor: 'var(--onds-surface)',
              }}
            >
              <span className="text-xs font-bold" style={p.self ? { color: 'var(--onds-accent)' } : undefined}>{p.symbol}</span>
              <span className="text-xs font-semibold tabular-nums" style={{ color }}>{formatSignedPercent(p.dayChangeRatio)}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
